export default "__VITE_ASSET__D1GnX0Wz__"